import { APP_INITIALIZER, NgModule } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import {
  AuthGuard,
  AuthHttpHeaderService,
  AuthInterceptor,
  AuthService,
  GlobalMessageService,
  UserIdService,
  WindowRef
} from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { EbCsagentAuthService } from '../asm/services/eb-csagent-auth.service'
import { EbAuthGuard } from './guards/eb-auth.guard'
import { EbAuthInterceptor } from './interceptor/eb-auth.interceptor'
import { EbAuthHttpHeaderService } from './services/eb-auth-http-header.service'
import { EbAuthStatePersistenceService } from './services/eb-auth-state-persistence.service'
import { EbAuthService } from './services/eb-auth.service'
import { EbUserIdService } from './services/eb-user-id.service'

export function authStatePersistenceFactory(
  authStatePersistenceService: EbAuthStatePersistenceService
) {
  return () => authStatePersistenceService.initializeSync()
}

@NgModule({
  providers: [
    EbAuthStatePersistenceService,
    {
      provide: 'Window',
      useValue: window
    },
    {
      provide: AuthService,
      useClass: EbAuthService
    },
    {
      provide: AuthGuard,
      useClass: EbAuthGuard
    },
    {
      provide: AuthHttpHeaderService,
      useClass: EbAuthHttpHeaderService
    },
    {
      provide: AuthInterceptor,
      useClass: EbAuthInterceptor
    },
    {
      provide: UserIdService,
      useClass: EbUserIdService
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authStatePersistenceFactory,
      deps: [EbAuthStatePersistenceService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: EbAuthService.handleSSOProcesses,
      multi: true,
      deps: [
        Store,
        GlobalMessageService,
        WindowRef,
        EbAuthStatePersistenceService,
        Router,
        CookieService,
        EbAuthService,
        EbCsagentAuthService
      ]
    }
  ]
})
export class EbAuthModule {}
